// <Icon type="audio" />
import React from 'react';
import { AnimationPlayer } from 'common/components/AnimationPlayer';
import { SpinePlayerWebGl } from '@/common/components/SpinePlayerWebGl';

interface ModelProps {
  model: any;
}

export default (props: ModelProps) => {
  const { model } = props;
  const { resourceUrl, isCoursewareNext, ...theModel } = model;
  if (isCoursewareNext) {
    return <SpinePlayerWebGl zipUrl={resourceUrl} width={800} height={400} />;
  }
  return <AnimationPlayer width={800} height={400} src={resourceUrl} {...theModel} />;
};
